module.exports = __webpack_public_path__ + "static/media/Soybean2VC.2078b9cd.PNG";